module.exports = __webpack_public_path__ + "static/graviturgy_wizard-1acc05f08c7306aa7d81e8d0db1ab804.png";